import { ConnextData, ProductModelService, UserPermissions } from "ngx-core-services";

import { SystemDefinition } from "../..";

export const checkAndUpdateAuthorizationInPlant = (system: SystemDefinition, myEmail: string): SystemDefinition => {
  let userLevel = 0;
  const isAwsPlant = system.source === 'aws';
  const isFirebasePlant = system.source === 'firebase';
  const withConnext = system.devices?.some(device => {
    const product = new ProductModelService(device.id);
    return product.type?.name === 'connext';
  });

  if (isFirebasePlant) {
    userLevel = withConnext ? (system.data as Partial<ConnextData>)?.userLevel ?? 0 : UserPermissions.Owner;
  } else if (isAwsPlant) {
    userLevel = system.aws?.users?.find(user => user.email === myEmail)?.userLevel ?? 0;
  }

  return {
    ...system,
    metadata: {
      /** Default to Europe/Rome */
      ...system.metadata,
      tz: system.metadata?.tz ?? 2,
      structure: system.metadata?.structure ?? 2,
      userLevel,
    },
  };
}
